/**
 * Leva a pessoa até uma linha da nota: rola, acende por um instante e põe o
 * foco na decisão dela — decisão 310.
 *
 * ## Por que existe
 *
 * "Confira na linha" e "1 sugestão não foi aceita" diziam o quê, mas não onde.
 * Numa nota de 41 linhas, interrompida, ao sol, achar a linha era caçar um
 * ponto amarelo de 6px (segunda crítica, P1).
 *
 * ## O foco vai na DECISÃO, e não na linha
 *
 * Quem chega pelo teclado quer agir: o foco cai no "Conferir" ou no ✓
 * (`data-acao-principal`), e Enter já decide. Sem eles — a linha que já foi
 * decidida —, cai no lápis, que é o gesto de toda linha.
 *
 * **O acender é um atributo, e não o anel de foco**: foco posto por programa
 * depois de um toque não ganha `:focus-visible` no Chromium, e quem tocou em
 * "Ir até ela" ficaria sem ver aonde chegou.
 */
export function irAteLinha(linhaId: string): void {
  const linha = document.getElementById(`linha-${linhaId}`)
  if (linha === null) return
  // `?.()` porque o jsdom não implementa `scrollIntoView`. `center`, e não
  // `start`: no celular a barra de abas cobre o fim da tela, e no desktop o
  // topo da coluna fica atrás de nada — o meio é o único lugar que serve aos dois.
  linha.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
  linha.dataset['destaque'] = 'true'
  window.setTimeout(() => {
    delete linha.dataset['destaque']
  }, 1600)
  const acao =
    linha.querySelector<HTMLElement>('[data-acao-principal]') ??
    linha.querySelector<HTMLElement>('[data-nav-linha]')
  acao?.focus({ preventScroll: true })
}
